import { Box, Center, Heading, Icon, Tooltip } from "@chakra-ui/react";
import _ from "lodash";
import { useSelector } from "react-redux";
import FilterForm from "../../../components/FilterForm";
import AverageWaitTimePerBranchReport from "../../../components/organization/reports/realtime/OrganizationAverageWaitTimePerBranch";
import { Helmet } from "react-helmet";
import { Info } from "lucide-react";
import { getReportDescription } from "../../../store/helpers";
import Loader from "../../../components/loader";

const OrganizationAverageWaitTimePerBranch = ({
  showFilterForm = false,
  reportIndex = 1,
}) => {
  const { reportRange, workDay } = useSelector((state) => state.defaultReducer);
  const reportTitle = `Average Wait Time Per Branch`;
  
  return (
    <Box>
      <Helmet>
        <title>{reportTitle}</title>
      </Helmet>
      {showFilterForm ? <FilterForm /> : <></>}
      <>
        <Heading fontSize="34px" color="#222" fontWeight="700">
          {reportTitle}
          <Tooltip.Root>
            <Tooltip.Trigger asChild>
              <Icon as={Info} w={5} h={5} ml={2} cursor="pointer" />
            </Tooltip.Trigger>
            <Tooltip.Positioner>
              <Tooltip.Content>
                {getReportDescription(reportRange)
                  .OrganizationAverageWaitTimePerBranch}
              </Tooltip.Content>
            </Tooltip.Positioner>
          </Tooltip.Root>
        </Heading>
        {_.isEmpty(workDay) ? (
          <Loader />
        ) : (
          <AverageWaitTimePerBranchReport reportIndex={reportIndex} />
        )}
      </>
    </Box>
  );
};

export default OrganizationAverageWaitTimePerBranch;
